import React, { useRef, useState } from "react"
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button,
    Media
} from "reactstrap";
// core components
import Header from "../../../../components/headers/Header";
import MessageBox from "../../../../components/ui/MessageBox";
import LoadingIndicator from "../../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import "antd/dist/antd.css";

import { PlusOutlined } from "@ant-design/icons";
import "../../../../assets/scss/screens/admin/unit/fields/types/uploadImage.scss";
import { Upload, Button as AntdBtn, Icon } from "antd";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as Helper from "../../../../utils/Helper";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../../redux/screens/admin/promotion/management/EditRedux";
import AuthorizedScreen from "../../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../../navigation";
import UIDs from "../../../../UIDs";
import { LocalizableTextField } from "../../unit/fields/types";
import HTMLEditor from "../../../../components/ui/HTMLEditor";

const uid = UIDs.screens.admin.promotion.management.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_PROMOTION_ASYNC]: { done: this._handleSavePromotionAsyncDone, error: this._handleAsyncActionError }
        };
    }

    localVars = {
        navParams: {
            id: null,
        }
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id } = this.localVars.navParams;
        if (id)
            this.props.loadScreenViewAsync(id);
        else
            this.props.createPromotion();
    }

    render() {
        const { promotionInfo } = this.props.localState;

        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <div className="col">
                            {!promotionInfo || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                                ? <LoadingIndicator />
                                : <EditForm
                                    {...this.props}
                                    onCancel={this._handleCancelEdit}
                                    onSave={this._handleSave}
                                    onUpload={this.props.uploadAsync}
                                    onRemove={this.props.remove}
                                    isDisabled={this.isActionExecuting(ActionTypes.SAVE_PROMOTION_ASYNC)}
                                    showLoading={this.isActionExecuting(ActionTypes.UPLOAD_ASYNC)}
                                />
                            }
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleSave = (data) => {
        if(Helper.isNullOrEmpty(data.startDate))
        {
            MessageBox.danger(this.props.t("msgStartDate"));
            return false;
        }

        if(Helper.isNullOrEmpty(data.endDate))
        {
            MessageBox.danger(this.props.t("msgEndDate"));
            return false;
        }

        if(new Date(data.startDate) >= new Date(data.endDate))
        {
            MessageBox.danger(this.props.t("msgWrongDate"));
            return;
        }
        const { banners } = this.props.localState;
        let copyWriting = [];
        for (var i = 0; i < data.copyWriting.length; i++) {
            if (data.copyWriting[i] && Helper.combineTranslation(data, "copyWriting", i) !== null) {
                copyWriting.push(Helper.combineTranslation(data, "copyWriting", i));
            }
        }

        let teacherRefundDesc = [];
        for (var i = 0; i < data.teacherRefundDesc.length; i++) {
            if (data.teacherRefundDesc[i] && Helper.combineTranslation(data, "teacherRefundDesc", i) !== null) {
                teacherRefundDesc.push(Helper.combineTranslation(data, "teacherRefundDesc", i));
            }
        }

        let agentRefundDesc = [];
        for (var i = 0; i < data.agentRefundDesc.length; i++) {
            if (data.agentRefundDesc[i] && Helper.combineTranslation(data, "agentRefundDesc", i) !== null) {
                agentRefundDesc.push(Helper.combineTranslation(data, "agentRefundDesc", i));
            }
        }

        let newData;
        newData = {
            id: data.id,
            name: data.name,
            startDate: new Date(data.startDate).toLocaleDateString(),
            endDate: new Date(data.endDate).toLocaleDateString(),
            banners: banners,
            participantRewardJson: { 
                type:0, 
                rewardData: {freeDays: data.freeVIPTime}
            },
            teacherRefundDesc: teacherRefundDesc,
            agentRefundDesc: agentRefundDesc,
            copyWriting: copyWriting,
            weChatBannerDescription: data.weChatBannerDescription,
            referralGuide: data.referralGuide,
            spreaderRewardJson: {
                type:0, 
                rewardData: {rewardStep: 5,rewardAmount:1.0}
            },
        };

        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        this.props.savePromotionAsync(newData);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleCancelEdit = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleSavePromotionAsyncDone = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }
}

function EditForm(props) {
    const { showLoading } = props;
    const { promotionInfo, banners } = props.localState;
    const { id, name, description, startDate, endDate,
        weChatBannerDescription, copyWriting: wenans=[], teacherRefundDesc: teacherIncomes=[], agentRefundDesc: agentIncomes=[], referralGuide: guide,
        spreaderRewardJson,
        participantRewardJson } = promotionInfo;
    let freeVIPTime = participantRewardJson ? participantRewardJson.rewardData.freeDays : "";
    const { register, handleSubmit, errors, setValue } = useForm();
    let formMethods = {
        register:register,
        errors: errors,
        setValue: setValue,
    }
    const submitRef = useRef();

    const [state_wenans, setstate_wenans] = useState(wenans);
    const [state_teacherIncomes, setstate_teacherIncomes] = useState(teacherIncomes);
    const [state_agentIncomes, setstate_agentIncomes] = useState(agentIncomes);
    const [state_initialFlag, setState_initialFlag] = useState(true);
    const [state_guide, setstate_guide] = useState(guide);
    const [state_languageImg, setstate_languageImg] = useState("zh");
    const [state_startDate, setstate_startDate] = useState(startDate ? new Date(startDate) : new Date());
    const [state_endDate, setstate_endDate] = useState(endDate ? new Date(endDate) : "");
    let minStartDate= new Date();
    let minEndDate = state_startDate ? new Date(state_startDate).setDate(new Date(state_startDate).getDate()+1) : new Date().setDate(new Date().getDate()+1);

    const pushIntoWenans = (tempWenans) => {
        let wenan = [];
        tempWenans.push(wenan);
    };

    const pushIntoTeacherIncomes = (tempTeacherIncomes) => {
        let income = "";
        tempTeacherIncomes.push(income);
    };

    const pushIntoAgentIncomes = (tempAgentIncomes) => {
        let income = "";
        tempAgentIncomes.push(income);
    };

    if (state_initialFlag) {
        //文案说明
        let tempWenans = [];
        if (wenans.length > 0) {
            wenans.forEach((wenan) => {
                tempWenans.push(wenan);
            });
        } else {
            pushIntoWenans(tempWenans);
        }

        //老师收益说明
        let tempTeacherIncomes = [];
        if (teacherIncomes.length > 0) {
            teacherIncomes.forEach((teacherIncome) => {
                tempTeacherIncomes.push(teacherIncome);
            });
        } else {
            pushIntoTeacherIncomes(tempTeacherIncomes);
        }

        //代理收益说明
        let tempAgentIncomes = [];
        if (agentIncomes.length > 0) {
            agentIncomes.forEach((teacherIncome) => {
                tempAgentIncomes.push(teacherIncome);
            });
        } else {
            pushIntoAgentIncomes(tempAgentIncomes);
        }

        setstate_wenans(tempWenans);
        setstate_teacherIncomes(tempTeacherIncomes);
        setstate_agentIncomes(tempAgentIncomes);
        setState_initialFlag(false);
    }

    //指南
    const _handleChangeEdit = (val) => {
        setstate_guide(val);
    }

    //添加图片的按钮
    const uploadButton = (
        <AntdBtn style={{width: 100, height: 100}}>
            <PlusOutlined />
        </AntdBtn>
    );

    //上传中文图片
    const uploadProps = {
        name: "fileData",
        multiple: true,
        showUploadList: false, // set to only upload one file
        customRequest: info => {
            props.onUpload({file: info.file, languageImg: state_languageImg});
        },
        beforeUpload: file => {
            const isCompPack = file.type === "image/jpeg" || file.type === "image/png";
            if (!isCompPack) {
                MessageBox.danger(props.t("uploadImageFormatLimited"));
                return false;
            }
            const isLt2M = file.size / 1024 / 1024 < 5;
            if (!isLt2M) {
                MessageBox.danger(props.t("uploadImageSizeLimited", { fileSize: 5 }));
                return false;
            }
            return isCompPack && isLt2M;
        }
    };

    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        {id ? "" : <h3>{props.t("title")}</h3>}
                    </Col>
                    <Col className="text-right" xs="4">
                        <Button
                            color="info"
                            onClick={() => submitRef.current.click()}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("save")}
                        </Button>&nbsp;
                        <Button
                            color="default"
                            onClick={props.onCancel}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("back")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <input name="id" hidden type="text" className="form-control" defaultValue={id} ref={register} />
                    <input name="startDate" hidden type="text" className="form-control" value={state_startDate} ref={register} />
                    <input name="endDate" hidden type="text" className="form-control" value={state_endDate} ref={register} />
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("name")}</label>
                                    <input name="name" type="text" className="form-control-alternative form-control" defaultValue={name} maxLength={300}
                                        ref={register({ required: true })} />
                                    {errors.name && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("freeVIPTime")}</label>
                                    <select name="freeVIPTime" ref={register} defaultValue={freeVIPTime} className="form-control-alternative form-control">
                                        <option value="30">{props.t("oneMonth")}</option>
                                        <option value="90">{props.t("threeMonth")}</option>
                                        <option value="180">{props.t("halfYear")}</option>
                                        <option value="365">{props.t("year")}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            {/*<div className="col-lg-6">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("startDate")}</label>
                                    <div><DatePicker
                                        name="startDate"
                                        className="form-control-alternative form-control"
                                        placeholderText={props.t("startDate")}
                                        selected={state_startDate}
                                        minDate={minStartDate}
                                        onChange={date => setstate_startDate(date)}
                                        dateFormat="yyyy/MM/dd"
                                    /></div>
                                </div>
                            </div>*/}
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("endDate")}</label>
                                    <div><DatePicker
                                        name="endDate"
                                        className="form-control-alternative form-control"
                                        placeholderText={props.t("endDate")}
                                        selected={state_endDate}
                                        minDate={minEndDate}
                                        onChange={date => setstate_endDate(date)}
                                        dateFormat="yyyy/MM/dd"
                                    /></div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("banners")}</label>
                                    <div>
                                        <Button color={state_languageImg === "zh" ? "primary" : ""} onClick={() => { setstate_languageImg("zh"); }} size="sm"> {props.t("btnzh")}</Button>
                                        <Button color={state_languageImg === "en" ? "primary" : ""} onClick={() => { setstate_languageImg("en"); }} size="sm"> {props.t("btnen")}</Button>
                                        <Button color={state_languageImg === "ko" ? "primary" : ""} onClick={() => { setstate_languageImg("ko"); }} size="sm"> {props.t("btnko")}</Button>
                                        <Button color={state_languageImg === "th" ? "primary" : ""} onClick={() => { setstate_languageImg("th"); }} size="sm"> {props.t("btnth")}</Button>
                                    </div>
                                    <div style={{marginTop:10, marginBottom: 10}}>
                                        <Upload {...uploadProps} >{showLoading ? <Icon type="loading" style={{fontSize:50}} /> : uploadButton}</Upload>
                                    </div>
                                    {state_languageImg === "zh" &&<div>
                                        {banners && banners.zh && banners.zh.map((path, i)=>{
                                            return(
                                                <div style={{float:"left", marginRight:10}}>
                                                    <img src={Helper.convertToFileServerPath(path)} alt="..." style={imgStyle} />
                                                    <div style={{float:"right", cursor:"pointer"}}>
                                                        <i class="fa fa-times" aria-hidden="true"
                                                            onClick={(e) => {props.onRemove({index: i, languageImg: "zh"})}}
                                                        ></i>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>}
                                    {state_languageImg === "en" &&<div>
                                        {banners && banners.en && banners.en.map((path, i)=>{
                                            return(
                                                <div style={{float:"left", marginRight:10}}>
                                                    <img src={Helper.convertToFileServerPath(path)} alt="..." style={imgStyle} />
                                                    <div style={{float:"right", cursor:"pointer"}}>
                                                        <i class="fa fa-times" aria-hidden="true"
                                                            onClick={(e) => {props.onRemove({index: i, languageImg: "en"})}}
                                                        ></i>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>}
                                    {state_languageImg === "ko" &&<div>
                                        {banners && banners.ko && banners.ko.map((path, i)=>{
                                            return(
                                                <div style={{float:"left", marginRight:10}}>
                                                    <img src={Helper.convertToFileServerPath(path)} alt="..." style={imgStyle} />
                                                    <div style={{float:"right", cursor:"pointer"}}>
                                                        <i class="fa fa-times" aria-hidden="true"
                                                            onClick={(e) => {props.onRemove({index: i, languageImg: "ko"})}}
                                                        ></i>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>}
                                    {state_languageImg === "th" &&<div>
                                        {banners && banners.th && banners.th.map((path, i)=>{
                                            return(
                                                <div style={{float:"left", marginRight:10}}>
                                                    <img src={Helper.convertToFileServerPath(path)} alt="..." style={imgStyle} />
                                                    <div style={{float:"right", cursor:"pointer"}}>
                                                        <i class="fa fa-times" aria-hidden="true"
                                                            onClick={(e) => {props.onRemove({index: i, languageImg: "th"})}}
                                                        ></i>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("weChatBannerDescription")}</label>
                                    <textarea name="weChatBannerDescription" rows="4" className="form-control-alternative form-control" defaultValue={weChatBannerDescription}
                                        ref={register} />
                                    {errors.description && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <div className="form-group practiceBlock">
                                        <label className="form-control-label practiceLabel">{props.t("copyWriting")}</label>
                                        <div style={{ float: "right", flexDirection: "row-reverse", justifyContent: "center" }}>
                                            <div
                                                style={{ float: "left", fontSize: "20px", color: "red", marginRight: "10px", cursor: "pointer" }}
                                                onClick={() => {
                                                    var tempWenans = JSON.parse(JSON.stringify(state_wenans));
                                                    pushIntoWenans(tempWenans);
                                                    setstate_wenans(tempWenans);
                                                }}
                                                title={props.t("add")}
                                            >
                                                <i className="fa fa-plus-circle" aria-hidden="true"></i>
                                            </div>
                                            <div
                                                style={{ float: "left", fontSize: "20px", color: "#5e72e4", marginRight: "10px", cursor: "pointer" }}
                                                onClick={() => {
                                                    if (state_wenans.length > 1) {
                                                        var tempWenans = JSON.parse(JSON.stringify(state_wenans));
                                                        tempWenans.pop();
                                                        setstate_wenans(tempWenans);
                                                    }
                                                }}
                                                title={props.t("deleteLastOne")}
                                            >
                                                <i className="fa fa-minus-circle" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        {state_wenans &&
                                            state_wenans.map((content, index) => {
                                                const fieldsForLocalizableTxt = {
                                                    text: {
                                                        name: "copyWriting",
                                                        label: props.t("copyWritingNum",{num: index+1}),
                                                        value: content,
                                                        index: index,
                                                    },
                                                };

                                                return (
                                                    <div key={index} className="practice">
                                                        <LocalizableTextField formMethods={formMethods} fields={fieldsForLocalizableTxt} />
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <label className="form-control-label practiceLabel">{props.t("referralGuide")}</label>
                                <input name="referralGuide" hidden type="text" className="form-control" value={state_guide} ref={register} />
                                <HTMLEditor height={400} htmlContent={state_guide} handleChangeEdit={_handleChangeEdit} />
                            </div>
                        </div>
                        <div className="row" style={{marginTop:20}}>
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label practiceLabel">{props.t("teacherRefundDesc")}</label>
                                    <div style={{ float: "right", flexDirection: "row-reverse", justifyContent: "center" }}>
                                        <div
                                            style={{ float: "left", fontSize: "20px", color: "red", marginRight: "10px", cursor: "pointer" }}
                                            onClick={() => {
                                                var tempTeacherIncomes = JSON.parse(JSON.stringify(state_teacherIncomes));
                                                pushIntoTeacherIncomes(tempTeacherIncomes);
                                                setstate_teacherIncomes(tempTeacherIncomes);
                                            }}
                                            title={props.t("add")}
                                        >
                                            <i className="fa fa-plus-circle" aria-hidden="true"></i>
                                        </div>
                                        <div
                                            style={{ float: "left", fontSize: "20px", color: "#5e72e4", marginRight: "10px", cursor: "pointer" }}
                                            onClick={() => {
                                                if (state_teacherIncomes.length > 1) {
                                                    var tempTeacherIncomes = JSON.parse(JSON.stringify(state_teacherIncomes));
                                                    tempTeacherIncomes.pop();
                                                    setstate_teacherIncomes(tempTeacherIncomes);
                                                }
                                            }}
                                            title={props.t("deleteLastOne")}
                                        >
                                            <i className="fa fa-minus-circle" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{marginTop: -20}}>
                            <div className="col-lg-12">
                                <div className="form-group">
                                    {state_teacherIncomes &&
                                        state_teacherIncomes.map((teacherIncome, index) => {
                                            const fieldsForLocalizableTxt = {
                                                text: {
                                                    name: "teacherRefundDesc",
                                                    label: props.t("refundNum",{num: index+1}),
                                                    value: teacherIncome,
                                                    index: index,
                                                },
                                            };

                                            return (
                                                <div key={index} className="practice">
                                                    <LocalizableTextField formMethods={formMethods} fields={fieldsForLocalizableTxt} />
                                                </div>
                                            );
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <div className="form-group practiceBlock">
                                        <label className="form-control-label practiceLabel">{props.t("agentRefundDesc")}</label>
                                        <div style={{ float: "right", flexDirection: "row-reverse", justifyContent: "center" }}>
                                            <div
                                                style={{ float: "left", fontSize: "20px", color: "red", marginRight: "10px", cursor: "pointer" }}
                                                onClick={() => {
                                                    var tempAgentIncomes = JSON.parse(JSON.stringify(state_agentIncomes));
                                                    pushIntoAgentIncomes(tempAgentIncomes);
                                                    setstate_agentIncomes(tempAgentIncomes);
                                                }}
                                                title={props.t("add")}
                                            >
                                                <i className="fa fa-plus-circle" aria-hidden="true"></i>
                                            </div>
                                            <div
                                                style={{ float: "left", fontSize: "20px", color: "#5e72e4", marginRight: "10px", cursor: "pointer" }}
                                                onClick={() => {
                                                    if (state_agentIncomes.length > 1) {
                                                        var tempAgentIncomes = JSON.parse(JSON.stringify(state_agentIncomes));
                                                        tempAgentIncomes.pop();
                                                        setstate_agentIncomes(tempAgentIncomes);
                                                    }
                                                }}
                                                title={props.t("deleteLastOne")}
                                            >
                                                <i className="fa fa-minus-circle" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group" style={{marginTop: -20}}>
                                        {state_agentIncomes &&
                                            state_agentIncomes.map((agentIncome, index) => {
                                                const fieldsForLocalizableTxt = {
                                                    text: {
                                                        name: "agentRefundDesc",
                                                        label: props.t("refundNum",{num: index+1}),
                                                        value: agentIncome,
                                                        index: index,
                                                    },
                                                };

                                                return (
                                                    <div key={index} className="practice">
                                                        <LocalizableTextField formMethods={formMethods} fields={fieldsForLocalizableTxt} />
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <input ref={submitRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card>
    );
}

const imgStyle = {
    width:"375px",
    height:"667px",
    marginRight:"10px"
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: id => dispatch(Actions.loadScreenViewAsync(id)),
        savePromotionAsync: vo => dispatch(Actions.savePromotionAsync(vo)),
        uploadAsync: vo => dispatch(Actions.uploadAsync(vo)),
        remove: vo => dispatch(Actions.remove(vo)),
        createPromotion: () => dispatch(Actions.createPromotion())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));